module.exports = __webpack_public_path__ + "static/media/background.3067cfac.svg";